/**
 * Main Entry Point
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';

// AG-Grid modules
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// AG-Grid Legacy 테마 (ag-theme-alpine) + 커스텀 스타일
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './styles/ag-grid-custom.css';

// Register AG-Grid modules
ModuleRegistry.registerModules([AllCommunityModule]);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
